import { useEffect, useState } from "react";
import SmallPopup from "../../components/modal/SmallPopup";
import { ReviewPopupTimeInfo } from "./ReviewPopup";
import { LOCAL_STORAGE_KEYS } from "../../constants/AppConstants";
import useAuth from "../../hooks/useAuth";
const ReviewPopupTimeInfoArea = function () {
  const [open, setOpen] = useState(false);
  const { ceoInfo } = useAuth();
  useEffect(() => {
    let period = localStorage.getItem(`${LOCAL_STORAGE_KEYS.PERIODNOTSHOWREVIEWPOPUP}-${ceoInfo.ceo_idx}`);
    period = period ? +period : 0;
    setOpen(new Date().getTime() > period);
  }, []);
  const closeModal = () => setOpen(false);
  return (
    <SmallPopup open={open} setOpen={setOpen}>
      <ReviewPopupTimeInfo closeModal={closeModal} />
    </SmallPopup>
  );
};

export default ReviewPopupTimeInfoArea;
